import axios from 'axios';
import {
  emitJiraRateLimit,
  isJiraApiUrl,
  isJiraRateLimitError,
  jiraErrorMessage,
} from '../utils/jiraErrors';

let installed = false;

function parseRetryAt(error: any): number | undefined {
  const headers = error?.response?.headers || {};
  const retryAt = headers['x-complic-retry-at'] || headers['X-Complic-Retry-At'];
  if (retryAt) {
    const n = Number(retryAt);
    if (Number.isFinite(n) && n > 1e9) return n * 1000; // epoch seconds → ms
    if (Number.isFinite(n) && n > 1e12) return n; // already ms
  }
  const ra = headers['retry-after'] || headers['Retry-After'];
  if (ra != null && ra !== '') {
    const sec = Number(ra);
    if (Number.isFinite(sec) && sec >= 0) return Date.now() + sec * 1000;
  }
  return undefined;
}

/** Install once — surfaces Jira 429 everywhere axios is used. */
export function installJiraAxiosInterceptor() {
  if (installed) return;
  installed = true;

  axios.interceptors.response.use(
    (response) => response,
    (error) => {
      try {
        const url = String(error?.config?.url || '');
        if (isJiraRateLimitError(error) || (error?.response?.status === 429 && isJiraApiUrl(url))) {
          emitJiraRateLimit(jiraErrorMessage(error), parseRetryAt(error));
        }
      } catch {
        /* ignore */
      }
      return Promise.reject(error);
    }
  );
}
